<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-horse-toy`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.52 4.987a1 1 0 01.192.018l1.376.27c8.042 1.571 12.462 5.027 12.462 10.45 0 .939 1.186 2.098 2.147 2.098h2.147c3 0 5.117.495 6.704 1.598 4.567-2.385 9.278-2.1 13.811.852l-2.382 3.492c-2.966-1.933-5.782-2.261-8.697-.985.433.873.815 1.871 1.174 3.006.812 2.567.945 2.953 1.439 3.996a11.82 11.82 0 001.349 2.22c1.033-1.238 1.632-2.51 1.632-3.689h4.294C45.168 35.603 34.041 43 23.697 43S2.226 35.604 2.226 28.313H6.52c0 .932.374 1.921 1.04 2.906l3.083-9.04-.79-1.542-3.123 1.527a1 1 0 01-1.138-.183l-3.305-3.23a1 1 0 01-.191-1.17L6.52 8.935V5.987a1 1 0 011-1zm15.103 27.522c-2.794 0-4.336 1.16-6.444 4.823 2.384.91 4.984 1.472 7.518 1.472 2.121 0 4.288-.393 6.336-1.055-.6-2.935-3.648-5.24-7.41-5.24zM10.783 9.988l-3.756 7.34 4.747-2.32 3.506 6.85-4.33 12.69c.437.315.899.62 1.381.912 2.923-5.142 5.42-7.147 10.292-7.147 5.414 0 10.037 3.248 11.401 7.738a22.044 22.044 0 002.027-1.227 15.735 15.735 0 01-2.056-3.28c-.608-1.286-.763-1.736-1.644-4.519-1.296-4.096-2.241-5.006-6.507-5.006h-2.147c-3.333 0-6.441-3.038-6.441-6.295 0-2.534-1.993-4.463-6.474-5.736z"/></svg>
</template>
<script>

export default {
  name: 'IconHorseToy',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
